import { h, defineComponent, ref } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { box, button, pageSubtitle } from '@/ui/components';
import { UpdateUserSeatsModal } from '@/ui/components/modals/UpdateUserSeatsModal';
import { isSubscriptionEnterprise, isSubscriptionFree } from '@/ui/helpers';
import { user } from '@/ui/auth/auth';

export const SeatsCount = defineComponent({
  name: 'SeatsCount',
  setup() {
    const userSeatsModal = ref(false);

    const openModal = (e: MouseEvent) => {
      e.preventDefault();

      userSeatsModal.value = true;
    };

    const getMessage = () => {
      return isSubscriptionEnterprise(user.value)
        ? t('subscription.please-contact-sales')
        : t('subscription.please-upgrade');
    };

    return function render() {
      return box([
        pageSubtitle(t('subscription.seat-details')),
        h('p', { class: 'description' }, t('subscription.seat-info')),
        h('div', [
          h(UpdateUserSeatsModal, {
            props: {
              active: userSeatsModal.value,
              ariaRole: 'dialog',
              trapFocus: true,
              destroyOnHide: true,
              ariaModal: true,
            },
            on: {
              close: () => {
                userSeatsModal.value = false;
              },
            },
          }),
          isSubscriptionEnterprise(user.value) || isSubscriptionFree(user.value)
            ? getMessage()
            : button(t('common.edit'), openModal),
        ]),
      ]);
    };
  },
});
